import {ModuleWithProviders, NgModule} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
  CreateNewTagUseCase,
  DeleteTagUseCase,
  EditTagUseCase,
  FindTagUseCase,
  ListCustomTagsUseCase,
  TagComponent,
  TagDeleteComponent,
  TagDetailComponent,
  TagsDetailFacade
} from "./feature";
import {AsksuiteCitrusModule} from "asksuite-citrus";
import {CommonModule} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {BASE_URL, CustomTagsBffGateway} from "./infra";
import {CustomTagsGateway} from "./domain";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

const createTagUseCaseFactory = (tagRepo: CustomTagsGateway) => new CreateNewTagUseCase(tagRepo)
const createUserProvider = {
  provide: CreateNewTagUseCase,
  factory: createTagUseCaseFactory,
  deps: [CustomTagsGateway]
}

const listTagsUseCaseFactory = (tagRepo: CustomTagsGateway) => new ListCustomTagsUseCase(tagRepo)
const listTagsUseCaseProvider = {
  provide: ListCustomTagsUseCase,
  factory: listTagsUseCaseFactory,
  deps: [CustomTagsGateway]
}

const findTagUseCaseFactory = (tagRepo: CustomTagsGateway) => new FindTagUseCase(tagRepo)
const findTagUseCaseProvider = {
  provide: FindTagUseCase,
  factory: findTagUseCaseFactory,
  deps: [CustomTagsGateway]
}

const editTagUseCaseFactory = (tagRepo: CustomTagsGateway) => new EditTagUseCase(tagRepo)
const editTagUseCaseProvider = {
  provide: EditTagUseCase,
  factory: editTagUseCaseFactory,
  deps: [CustomTagsGateway]
}

const deleteTagUseCaseFactory = (tagRepo: CustomTagsGateway) => new DeleteTagUseCase(tagRepo)
const deleteTagUseCaseProvider = {
  provide: DeleteTagUseCase,
  factory: deleteTagUseCaseFactory,
  deps: [CustomTagsGateway]
}

@NgModule({
  providers: [
    {
      provide: CustomTagsGateway,
      useFactory: (httpClient: HttpClient, baseBffUrl: string) => {
        return new CustomTagsBffGateway(httpClient, baseBffUrl)
      },
      deps: [HttpClient, BASE_URL]
    },
    createUserProvider,
    listTagsUseCaseProvider,
    findTagUseCaseProvider,
    editTagUseCaseProvider,
    deleteTagUseCaseProvider,
    TagsDetailFacade
  ],
  declarations: [
    TagDetailComponent,
    TagDeleteComponent,
    TagComponent
  ],
  imports: [
    CommonModule,
    AsksuiteCitrusModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    TagDetailComponent,
    TagDeleteComponent,
    TagComponent
  ]
})
export class TagsModule {
  static forRoot(params: { baseBffUrl: string }): ModuleWithProviders<TagsModule> {
    return {
      ngModule: TagsModule,
      providers: [
        {
          provide: BASE_URL,
          useValue: params.baseBffUrl
        }
      ]
    }
  }
}
